export default __webpack_public_path__ + "static/media/contract_icon.b0058077.svg";